import { CircularProgress, Stack, styled } from '@mui/material'

/**
 * Loader
 * @constructor
 */
const Loader = () => {
	return (
		<Container>
			<CircularProgress size="24px" color="inherit" />
		</Container>
	)
}

const Container = styled(Stack)({
	alignItems: 'center',
	flex: 1,
	justifyContent: 'center'
})

export default Loader
